type ErrorMap = {
  [x: number]: string;
};

export const errorStatus = [400];
export const errorStatusToMessage: ErrorMap = {
  400: "Bad request",
};
